import React from "react";
import services from "../../services";
import { withRouter } from "react-router-dom";
import TitleBar from "../common/title_bar";
import SearchFilter from "../filters/SearchFilter";
import Main from "../../Pages/Demo/main";
import Lang from "../../lang";
import TlkTable from "../tlelrik/table/tlkTable";
import axios from "axios";

const filters = {
    Tabs: {
        Estatuto: [
            {
                key: "moduloFiscalizacao",
                displayKey: "Procurar por Módulo Fiscalização",
                inputType: "dropdown",
                option: [
                    { key: "Sim", value: "Sim" },
                    { key: "Não", value: "Não" },
                ],
            },
            {
                key: "moduloVindima",
                displayKey: "Procurar por Módulo Vindima",
                inputType: "dropdown",
                option: [
                    { key: "Sim", value: "Sim" },
                    { key: "Não", value: "Não" },
                ],
            },
            {
                key: "moduloParcela",
                displayKey: "Procurar por Módulo Parcela",
                inputType: "dropdown",
                option: [
                    { key: "Sim", value: "Sim" },
                    { key: "Não", value: "Não" },
                ],
            },
            {
                key: "moduloConvocatoria",
                displayKey: "Procurar por Módulo Convocatória",
                inputType: "dropdown",
                option: [
                    { key: "Sim", value: "Sim" },
                    { key: "Não", value: "Não" },
                ],
            },
            {
                key: "moduloInstalacoesVinicas",
                displayKey: "Procurar por Módulo Instalações Vínicas",
                inputType: "dropdown",
                option: [
                    { key: "Sim", value: "Sim" },
                    { key: "Não", value: "Não" },
                ],
            },
            {
                key: "moduloContaCorrente",
                displayKey: "Procurar por Módulo Conta Corrente",
                inputType: "dropdown",
                option: [
                    { key: "Sim", value: "Sim" },
                    { key: "Não", value: "Não" },
                ],
            },
        ],
    },
    checkbox: [],
};

const columnkeyMap = {
    codEstatuto: "Cod Estatuto",
    estatuto: "Descrição",
    moduloContaCorrente: "Corrente",
    moduloFiscalizacao: "Fiscalização",
    moduloVindima: "Vindima",
    moduloParcela: "Parcela",
    moduloConvocatoria: "Convocatória",
    moduloInstalacoesVinicas: "Instalações Vínicas",
};

class EstotusListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            telkikTable: "",
            tlkState: null,
            totalcount: "0",
            SortBy: "codEstatuto",
            IsSortTypeDESC: false,
            Paginate: true,
            Page: 1,
            PageSize: 100,
            Filters: null,
            filterData: [],
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.createpayload();
        //this.getStatusFromServcie();
    }

    createpayload = () => {
        let data = {
            Filters: this.state.Filters,
            SortBy: this.state.SortBy,
            IsSortTypeDESC: this.state.IsSortTypeDESC,
            IsPagination: this.state.Paginate,
            Page: this.state.Page,
            PageSize: this.state.PageSize,
        };
        this.getEstatosList(data);
    };
    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    // getFilters = (data) => {
    // //console.log("data",data)
    // if(data){
    //     //console.log("data",data)
    //     this.setState({
    //         Filters : data
    //     },()=>this.createpayload())
    // }else{
    //     //console.log("data Else",data)
    //     this.setState({
    //         Filters : null
    //     },()=>this.createpayload())
    // }
    // }

    getFilters = (customfilters) => {
        let Filters = {};
        // debugger;
        console.log(".........", customfilters);
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.moduloFiscalizacao
        )
            Filters["Fiscalizacao"] =
                customfilters.filters.moduloFiscalizacao === "Sim"
                    ? true
                    : false;
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.moduloVindima
        )
            Filters["Vindima"] =
                customfilters.filters.moduloVindima === "Sim" ? true : false;
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.moduloParcela
        )
            Filters["Parcela"] =
                customfilters.filters.moduloParcela === "Sim" ? true : false;
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.moduloConvocatoria
        )
            Filters["Convocatoria"] =
                customfilters.filters.moduloConvocatoria === "Sim"
                    ? true
                    : false;
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.moduloContaCorrente
        )
            Filters["ContaCorrente"] =
                customfilters.filters.moduloContaCorrente === "Sim"
                    ? true
                    : false;
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.moduloInstalacoesVinicas
        )
            Filters["InstalacoesVinicas"] =
                customfilters.filters.moduloInstalacoesVinicas === "Sim"
                    ? true
                    : false;            
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.estatuto
        )
            Filters["Estatuto"] =
                customfilters.filters.estatuto === "Sim" ? true : false;

        this.setState({ Filters: Filters, telkikTable: null }, () =>
            this.createpayload()
        );
    };

    handleFilter = (data) => {
        // let actionbuttons= {Edit:true,Redirect:false,Delete:true}
        // let telkikTable = <Main date={new Date()} list={data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action,id)=>this.ActionPerform(action,id)}/>
        // this.setState({
        //     telkikTable: null,
        //     filterData: data
        // }, () => this.createTabel())
    };

    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (row) => {
        let res = await services.apiCall.requestApi(
            `/Estatuto/Delete/${row.codEstatuto}`,
            {},
            "post"
        );
        if (res) {
            //console.log("res",row)
            this.createpayload();
        }
    };

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: "checkbox" };
    });

    createTabel = () => {
        let actionbuttons = { Edit: true, Redirect: false };
        //console.log("DATA",this.state.data);
        //   let telkikTable = <Main date={new Date()} deleteFunc={(id)=>this.handleDelete(id)} list={this.state.data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action,id)=>this.ActionPerform(action,id)}/>
        let telkikTable = (
            <TlkTable
                
                tlkState={this.state.tlkState}
                tableFilters={(filter) => this.tableFilters(filter)}
                date={new Date()}
                modulename={"estatosList"}
                deleteFunc={(id) => this.handleDelete(id)}
                list={this.state.filterData}
                actionbuttons={actionbuttons}
                columnlist={this.columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
            />
        );
        this.setState({
            telkikTable: telkikTable,
        });
    };

    // getStatusFromServcie = async () => {
    //     try {
    //         const res = await services.apiCall.requestApi(
    //             "/Estatuto/Estatutos",
    //             {},
    //             "get"
    //         );
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    tableFilters = (filter) => {
        if (JSON.stringify(this.state.tlkState) !== JSON.stringify(filter)) {
            let tlkState = { ...filter };
            let SortBy = "ID";
            let IsSortTypeDESC = false;
            let columnkeyMaprev = {};
            for (var key in columnkeyMap) {
                columnkeyMaprev[columnkeyMap[key]] = key;
            }
            if (filter && filter.sort && filter.sort.length > 0) {
                SortBy = columnkeyMaprev[filter.sort[0].field];
                IsSortTypeDESC = filter.sort[0].dir === "asc" ? false : true;
            }
            this.setState(
                {
                    Page: Math.ceil(filter.skip / filter.take) + 1,
                    PageSize: filter.take || 100,
                    SortBy,
                    IsSortTypeDESC,
                    tlkState,
                },
                () => {
                    this.createpayload();
                }
            );
        }
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (action == "Edit") {
            //console.log("row.codEstatuto",row)
            this.props.history.push({
                pathname: "/estato_detail",
                search: "id=" + row.detalheURL,
                state: {
                    // estatos_id: row.codEstatuto,
                    topBarMenu: this.props.topBarMenuOption,
                },
            });
        }
    };
    getEstatosList = async (data) => {
        let _user = await services.apiCall.requestApi(
            "/Estatuto/GetAll",
            data,
            "post"
        );
        if (_user) {
            _user.map((_row, index) =>
                Object.keys(columnkeyMap).map(function (key) {
                    _row[columnkeyMap[key]] = _row[key];
                })
            );
            this.setState(
                {
                    data: _user,
                    filterData: _user,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => this.createTabel()
            );
        }
    };

    render() {
        //console.log("hjdsdk",this.state.Filters)
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        topBarMenu={this.props.topBarMenuOption}
                        path={"/estato_detail"}
                        title="Estatutos"
                        logo="auditing"
                    />
                    <SearchFilter
                        searchplaceholder={"pesquisar por estatuto"}
                        showEstatutoSearch={true}
                        filters={filters}
                        handleFilter={(data) => this.handleFilter(data)}
                        data={this.state.data}
                        getFilter={(data) => this.getFilters(data)}
                    />
                    <div className="table-responsive table-section">
                        <h3>
                            {" "}
                            A pesquisa retornou {this.state.totalcount}{" "}
                            resultados{" "}
                        </h3>
                        {this.state.telkikTable}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EstotusListComponent);
